import { sortBy, filter, map } from 'lodash';
import React from 'react';

import AnswerLanguageEditor from './AnswerLanguageEditor';
import answerLanguagesResource from 'src/actions/answers/answerLanguagesResource';
import { default as AnswerLanguagesList } from '@ad-scripts/domain/models/languages/answer_languages';
import RouterLinkButton from 'src/presentation/components/RouterLinkButton';
import TablePage, { TablePageRender } from 'src/presentation/components/pages/shared/TablePage';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import { isLoadingStatus } from 'src/presentation/hooks/useResource';

const dataAidPrefix = 'answer-languages-';

const columnConfig = [{ attr: 'language', label: 'Language' }];

const renderRowActions = () => null;

const AnswerLanguages: TablePageRender = ({ root }) => {
  const { errors, loadingState, value } = useDocumentResource(answerLanguagesResource);
  const answerLanguages = sortBy(
    map(value, lang => ({ id: lang, language: AnswerLanguagesList[lang] || '' })),
    v => v.language
  );

  function filterFunc(items, searchString) {
    if (!searchString) {
      return items;
    }
    const results = filter(items, item => {
      return item.language.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
    });
    return results;
  }
  const actions = (
    <RouterLinkButton data-aid={`${dataAidPrefix}addNew`} to={`${root}/new`}>
      Add Language
    </RouterLinkButton>
  );
  const description = (
    <span>
      Languages are used as part of Answers and Answer Keyword Groups. Only languages added here will be shown
      throughout Gladly. If there is a language that is not available to be added, reach out to Gladly support. Please
      note that languages cannot be removed once they are added.{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://help.gladly.com/docs/add-and-remove-answer-languages/">
        Learn more about managing answer languages
      </a>
      .
    </span>
  );

  return (
    <TablePage
      actions={actions}
      columnConfig={columnConfig}
      description={description}
      editor={AnswerLanguageEditor}
      errors={errors}
      filterFunc={filterFunc}
      isLoading={isLoadingStatus(loadingState)}
      items={answerLanguages}
      name="Languages"
      resetErrors={answerLanguagesResource.actions.resetErrors}
      root={root}
      renderRowActions={renderRowActions}
      data-aid={`${dataAidPrefix}page`}
    />
  );
};

export default AnswerLanguages;
